export default __webpack_public_path__ + "images/EJ.27b6cba.png";